var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useGetModuleRecordQuery } from "@/store/api";
import Preview from "../list/preview";
import { faPen } from "@fortawesome/pro-regular-svg-icons";
import { MenuItem } from "@mui/joy";
export default function FavoriteRecord(_a) {
    var record = _a.record, _b = _a.isVertical, isVertical = _b === void 0 ? false : _b;
    var _c = useState({}), favoriteRecord = _c[0], setFavoriteRecord = _c[1];
    var response = useGetModuleRecordQuery({
        moduleName: record.type,
        recordId: record.id,
    }).data;
    useEffect(function () {
        var data = (response === null || response === void 0 ? void 0 : response.data) || {};
        var recordData = (data === null || data === void 0 ? void 0 : data.record) || {};
        setFavoriteRecord(recordData);
    }, [response]);
    var _d = useState(false), clicked = _d[0], setClicked = _d[1];
    var handleClick = function (value) {
        setClicked(value);
    };
    return (_jsx(_Fragment, { children: isVertical ? (_jsx("div", { children: record.attributes.name && record.attributes.name !== "" && (_jsx("li", __assign({ className: "m-1 min-h-6" }, { children: _jsxs("div", __assign({ className: "flex flex-row justify-between items-center" }, { children: [_jsx("a", __assign({ href: "".concat(process.env.PUBLIC_URL, "/modules/").concat(record.type, "/DetailView/").concat(record.id), className: "hover:text-blue-300 pl-1 mr-1" }, { children: _jsx("span", __assign({ className: "text-sm uppercase" }, { children: record.attributes.name })) })), _jsx("span", __assign({ className: "flex flex-row justify-end mr-1" }, { children: _jsx("span", { children: _jsx(Preview, { record: favoriteRecord, module: record.type, handleClick: handleClick, className: "text-sm text-gray-300" }) }) }))] })) }))) })) : (_jsx("div", __assign({ className: "" }, { children: _jsxs(MenuItem, __assign({ sx: {
                    background: "var(--colors-widget)",
                    margin: "0 0 4px 0",
                    cursor: "auto",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                } }, { children: [_jsx("a", __assign({ href: "/modules/".concat(record.type, "/DetailView/").concat(record.id), className: "mr-1" }, { children: record.attributes.name })), _jsxs("span", __assign({ className: "flex flex-row justify-end" }, { children: [_jsx("span", { children: _jsx(Preview, { record: favoriteRecord, module: record.type, handleClick: handleClick }) }), _jsx("a", __assign({ href: "".concat(process.env.PUBLIC_URL, "/modules/").concat(record.type, "/EditView/").concat(record.id), className: "pt-1 hover:text-gray-500 text-gray-300" }, { children: _jsx(FontAwesomeIcon, { icon: faPen, size: "sm" }) }))] }))] })) }))) }));
}
